<template>
  <el-dialog
    center
    append-to-body
    modal-append-to-body
    title="修改密码"
    custom-class="password-dialog"
    :visible.sync="dialogVisible"
  >
    <el-form
      size="small"
      ref="formPassword"
      :rules="formPasswordRules"
      :model="formPassword"
    >
      <el-form-item label="输入新密码：" prop="password">
        <el-input show-password v-model="formPassword.password" />
      </el-form-item>
      <el-form-item label="确认新密码：" prop="re_password">
        <el-input show-password v-model="formPassword.re_password" />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="medium" @click="dialogVisible = false">取消</el-button>
      <el-button size="medium" type="primary" :loading="submitting" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getInfo, updatePassword } from "@/api/user";

export default {
  name: "ProfileChangePasswordDialog",
  props: ["visible"],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.formPassword.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      submitting: false,
      user_info: {},
      formPassword: {
        password: "",
        re_password: ""
      },
      formPasswordRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        re_password: [
          { required: true, validator: validatePassword, trigger: "blur" },
        ]
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        Object.keys(this.formPassword).forEach((item) => {
          this.$set(this.formPassword, item, "");
        });
        this.loadUserInfo();
      }
    },
  },
  methods: {
    async loadUserInfo() {
      try {
        const response = await getInfo();
        if (response && response.err_code === 0) {
          this.user_info = response.data || {};
        }
      } catch (error) {
        this.$message.error("获取个人信息失败");
      }
    },
    submit() {
      this.$refs.formPassword.validate(async valid => {
        if (!valid) {
          return;
        }

        if (!this.user_info.id) {
          this.$message.error("未获取到当前用户信息");
          return;
        }

        this.submitting = true;
        try {
          const response = await updatePassword({
            id: this.user_info.id,
            password: this.formPassword.password
          });
          if (response && response.err_code === 0) {
            this.$message.success("修改成功");
            this.dialogVisible = false;
          }
        } catch (error) {
          this.$message.error("密码修改失败");
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style lang="less">
.password-dialog {
  width: 600px;
  .el-form {
    .el-form-item {
      display: flex;
      .el-form-item__label {
        width: 120px;
        text-align: left;
      }
      .el-form-item__content {
        display: flex;
        width: 372px;
        .el-input {
          width: 260px;
        }
        .sms-input {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
